<template>
	<div
		class="pagination display-flex justify-content-center align-items-center"
		v-if="visiblePaginationTriggers > 1"
	>
		<b-button
			link
			class="button-pagination font-size-big"
			:disabled="isPreviousButtonDisabled"
			@clickOrEnter="pageChangeHandle('previous')"
		>
			<b-icon class="padding-right-tiny"><icon-chevron-left></icon-chevron-left></b-icon>Anterior
		</b-button>

		<div
			v-for="(paginationTrigger, index) in paginationTriggersSelection()"
			:key="index"
			:class="[visiblePaginationTriggers <= 2 ? 'display-md-none' : 'display-md-flex']"
			class="display-none align-items-center"
		>
			<p v-if="index === 1 && gapLeft" class="margin-0 padding-tiny">...</p>
			<p
				:class="[
					{ 'base-pagination__description--current': paginationTrigger === currentPage },
					'base-pagination__description',
					'font-size-big',
					'blue-base',
					'margin-0',
					'padding-tiny'
				]"
				@click="pageChangeHandle(paginationTrigger)"
			>
				{{ paginationTrigger }}
			</p>
			<p v-if="index === visiblePaginationTriggers - 2 && gapRight" class="margin-0 padding-tiny">
				...
			</p>
		</div>

		<b-button
			link
			class="button-pagination font-size-big"
			:disabled="isNextButtonDisabled"
			@clickOrEnter="pageChangeHandle('next')"
		>
			Próxima<b-icon class="padding-left-tiny"><icon-chevron-right></icon-chevron-right></b-icon>
		</b-button>
	</div>
</template>

<script>
import BButton from './Button.vue';
import BIcon from './Icon';
import IconChevronLeft from '../icons/icon-chevron-left.svg';
import IconChevronRight from '../icons/icon-chevron-right.svg';

export default {
	name: 'b-pagination',
	components: {
		BButton,
		BIcon,
		IconChevronLeft,
		IconChevronRight
	},
	props: {
		/**
		 * Número total de páginas, utilizado para compor as extremidades da paginação
		 */
		pageCount: {
			type: Number,
			required: true
		},
		/**
		 * Número atual da página. 1 é a página inicial
		 */
		currentPage: {
			type: Number,
			default: 1
		},
		/**
		 * Quantidade de páginas exibida no componente. 9 é a quantidade padrão
		 */
		visiblePagesCount: {
			type: Number,
			default: 9
		}
	},
	data() {
		return {
			visiblePages: this.visiblePagesCount,
			gapLeft: false,
			gapRight: false
		};
	},
	computed: {
		isPreviousButtonDisabled() {
			return this.currentPage === 1;
		},
		isNextButtonDisabled() {
			return this.currentPage === this.pageCount;
		},

		visiblePaginationTriggers() {
			return this.visiblePages > this.pageCount ? this.pageCount : this.visiblePages;
		}
	},
	methods: {
		paginationTriggersSelection() {
			const visiblePagesThreshold = Math.round((this.visiblePaginationTriggers - 2) / 2);
			const paginationTriggersArray = Array(this.visiblePaginationTriggers - 1).fill(0);

			if (this.currentPage <= visiblePagesThreshold + 1) {
				this.gapLeft = false;
				this.gapRight = this.visiblePaginationTriggers === this.pageCount ? false : true;
				paginationTriggersArray[0] = 1;
				const paginationTriggers = paginationTriggersArray.map((paginationTrigger, index) => {
					return paginationTriggersArray[0] + index;
				});
				paginationTriggers.push(this.pageCount);
				return paginationTriggers;
			} else if (this.currentPage >= this.pageCount - visiblePagesThreshold) {
				this.gapLeft = this.visiblePaginationTriggers === this.pageCount ? false : true;
				this.gapRight = false;
				const paginationTriggers = paginationTriggersArray.map((paginationTrigger, index) => {
					return this.pageCount - index;
				});
				paginationTriggers.reverse().unshift(1);
				return paginationTriggers;
			} else {
				this.gapLeft = true;
				this.gapRight = true;
				paginationTriggersArray[0] = Math.round(this.currentPage - visiblePagesThreshold + 1);
				const paginationTriggers = paginationTriggersArray.map((paginationTrigger, index) => {
					return paginationTriggersArray[0] + index;
				});
				paginationTriggers.unshift(1);
				paginationTriggers[paginationTriggers.length - 1] = this.pageCount;
				return paginationTriggers;
			}
		},
		pageChangeHandle(page) {
			/**
			 * Evento emitido quando uma página é selecionada
			 */
			switch (page) {
				case 'next':
					this.$emit('loadPage', this.currentPage + 1);
					break;
				case 'previous':
					this.$emit('loadPage', this.currentPage - 1);
					break;
				default:
					this.$emit('loadPage', page);
			}
		}
	}
};
</script>

<style>
.base-pagination__description {
	border-radius: 100%;
	cursor: pointer;
	width: 3.6rem;
	height: 3.6rem;
	text-align: center;
}
.base-pagination__description--current {
	background-color: #e7edff;
}
.button-pagination {
	font-weight: 400 !important;
}
</style>

<docs>
    Paginação

    ```js
        <bbox-pagination ref="pagination" :pageCount="10" ></bbox-pagination>
    ```
</docs>
